import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from "react-dom";
import { App } from "./App";
var init = null;
var app = {
    config: function (config) {
        init = config;
    },
    new: function () {
        return {
            render: function () {
                ReactDOM.render(_jsx(App, { lang: init.lang, title: init.title, widget: init.widget, entity: init.entity, edition: init.edition, indicator: init.indicator, darkHeader: init.darkHeader, displayTop: init.displayTop, competition: init.competition, isSidebarWidget: init.isSidebarWidget, competitionDefault: init.competitionDefault }), document.querySelector(init.selector));
            },
            unmount: function () {
                ReactDOM.unmountComponentAtNode(document.querySelector(init.selector));
            },
        };
    }
};
export default app;
